exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1gop7q4bCchow_bCsGR2xp{top:0;bottom:0;position:absolute;z-index:3001}html[dir=ltr] ._1gop7q4bCchow_bCsGR2xp,html[dir=rtl] ._1gop7q4bCchow_bCsGR2xp{left:0;right:0}._3Aug-3iJYlDVJH1X_Xo95r{position:fixed;top:0;bottom:0;width:100%;height:100%}html[dir] ._3Aug-3iJYlDVJH1X_Xo95r{border:0;margin:0;padding:0}html[dir=ltr] ._3Aug-3iJYlDVJH1X_Xo95r,html[dir=rtl] ._3Aug-3iJYlDVJH1X_Xo95r{left:0;right:0}", ""]);
// Exports
exports.locals = {
	"immersiveReaderContainer": "_1gop7q4bCchow_bCsGR2xp",
	"immersiveReaderIframe": "_3Aug-3iJYlDVJH1X_Xo95r"
};